<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Andrew MacMichael lives and works in the West Midlands with his wife, five cats and numerous children. Before writing speculative science fiction, he worked initially as a lawyer, and later in the accountancy profession. Andrew became interested in climate change whilst at Southampton University studying environmental law. He believes that mankind is now faced with a stark ultimatum—adapt or face extinction.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?59288bac